import { Compass } from "lucide-react";
import { Link } from "react-router-dom";
import { APP_VERSION } from "@/lib/version";

export const Footer = () => (
  <footer className="mt-24 border-t border-border bg-secondary/40">
    <div className="mx-auto max-w-7xl px-4 sm:px-8 lg:px-12 py-12">
      <div className="flex flex-col md:flex-row justify-between gap-8">
        <div className="max-w-sm">
          <div className="flex items-center gap-2 mb-3">
            <Compass className="h-5 w-5 text-accent" />
            <span className="font-display text-sm font-bold tracking-[0.15em]">ANOMALOUS // EARTH</span>
          </div>
          <p className="text-sm text-muted-foreground leading-relaxed">
            A living archive of the structures, religions and languages across the world that
            resist complete explanation.
          </p>
        </div>
        <div className="flex gap-12">
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-accent mb-3">Explore</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/archive" className="hover:text-foreground transition-colors">Archive Index</Link></li>
              <li><Link to="/map" className="hover:text-foreground transition-colors">Interactive Map</Link></li>
              <li><Link to="/definitions" className="hover:text-foreground transition-colors">Definitions</Link></li>
            </ul>
          </div>
          <div>
            <p className="font-mono text-xs uppercase tracking-widest text-accent mb-3">Areas</p>
            <ul className="space-y-2 text-sm text-muted-foreground">
              <li><Link to="/archive?area=structures" className="hover:text-foreground transition-colors">Structures</Link></li>
              <li><Link to="/archive?area=religion" className="hover:text-foreground transition-colors">Religion</Link></li>
              <li><Link to="/archive?area=language" className="hover:text-foreground transition-colors">Language</Link></li>
            </ul>
          </div>
        </div>
      </div>
      <div className="mt-10 pt-6 border-t border-border flex flex-col sm:flex-row justify-between gap-2 font-mono text-[11px] uppercase tracking-widest text-muted-foreground">
        <span>Copyright 2026 by <a href="https://billcasso.com" target="_blank" rel="noopener noreferrer" data-testid="footer-billcasso-link" className="text-accent hover:underline">BillCasso</a></span>
        <span data-testid="app-version">v{APP_VERSION}</span>
      </div>
    </div>
  </footer>
);

